import { provide } from 'vue'

import type { InjectionKey, Ref } from 'vue'

type ForwardRefSetter = <T>(sg: T) => void

export type ForwardRefInjectionContext = {
  setForwardRef: ForwardRefSetter
}

export const FORWARD_REF_INJECTION_KEY: InjectionKey<ForwardRefInjectionContext> =
  Symbol('elForwardRef')

export const useForwardRef = <T>(forwardRef: Ref<T | null>) => {
  const setForwardRef = ((sg: T) => {
    forwardRef.value = sg
  }) as ForwardRefSetter

  provide(FORWARD_REF_INJECTION_KEY, {
    setForwardRef,
  })
}

export const useForwardRefDirective = (setForwardRef: ForwardRefSetter) => {
  return {
    mounted(sg) {
      setForwardRef(sg)
    },
    updated(sg) {
      setForwardRef(sg)
    },
    unmounted() {
      setForwardRef(null)
    },
  }
}
